import { LabelAngleReferences, LabelPlacements, LayoutExecutor, MinimumNodeSizeStage, PreferredPlacementDescriptor, TimeSpan } from "yfiles";
export var LabelPlacementAlongEdge;
(function (LabelPlacementAlongEdge) {
    LabelPlacementAlongEdge[LabelPlacementAlongEdge["ANYWHERE"] = 0] = "ANYWHERE";
    LabelPlacementAlongEdge[LabelPlacementAlongEdge["AT_SOURCE"] = 1] = "AT_SOURCE";
    LabelPlacementAlongEdge[LabelPlacementAlongEdge["AT_TARGET"] = 2] = "AT_TARGET";
    LabelPlacementAlongEdge[LabelPlacementAlongEdge["CENTERED"] = 3] = "CENTERED";
    LabelPlacementAlongEdge[LabelPlacementAlongEdge["AT_SOURCE_PORT"] = 4] = "AT_SOURCE_PORT";
    LabelPlacementAlongEdge[LabelPlacementAlongEdge["AT_TARGET_PORT"] = 5] = "AT_TARGET_PORT";
})(LabelPlacementAlongEdge || (LabelPlacementAlongEdge = {}));
export var LabelPlacementSideOfEdge;
(function (LabelPlacementSideOfEdge) {
    LabelPlacementSideOfEdge[LabelPlacementSideOfEdge["ANYWHERE"] = 0] = "ANYWHERE";
    LabelPlacementSideOfEdge[LabelPlacementSideOfEdge["ON_EDGE"] = 1] = "ON_EDGE";
    LabelPlacementSideOfEdge[LabelPlacementSideOfEdge["LEFT"] = 2] = "LEFT";
    LabelPlacementSideOfEdge[LabelPlacementSideOfEdge["RIGHT"] = 3] = "RIGHT";
    LabelPlacementSideOfEdge[LabelPlacementSideOfEdge["LEFT_OR_RIGHT"] = 4] = "LEFT_OR_RIGHT";
})(LabelPlacementSideOfEdge || (LabelPlacementSideOfEdge = {}));
export var LabelPlacementOrientation;
(function (LabelPlacementOrientation) {
    LabelPlacementOrientation[LabelPlacementOrientation["PARALLEL"] = 0] = "PARALLEL";
    LabelPlacementOrientation[LabelPlacementOrientation["ORTHOGONAL"] = 1] = "ORTHOGONAL";
    LabelPlacementOrientation[LabelPlacementOrientation["HORIZONTAL"] = 2] = "HORIZONTAL";
    LabelPlacementOrientation[LabelPlacementOrientation["VERTICAL"] = 3] = "VERTICAL";
})(LabelPlacementOrientation || (LabelPlacementOrientation = {}));
class LayoutConfiguration {
    constructor() {
        this.$layoutRunning = false;
    }
    async apply(graphComponent, doneHandler, errorHandler) {
        if (this.$layoutRunning) {
            setTimeout(doneHandler, 10);
            this.$layoutRunning = false;
            return;
        }
        this.$layoutRunning = true;
        const layout = this.createConfiguredLayout ? this.createConfiguredLayout(graphComponent) : null;
        if (layout === null) {
            setTimeout(doneHandler, 10);
            this.$layoutRunning = false;
            return;
        }
        const layoutData = this.createConfiguredLayoutData
            ? this.createConfiguredLayoutData(graphComponent, layout)
            : null;
        const layoutExecutor = new LayoutExecutor({
            graphComponent,
            layout: new MinimumNodeSizeStage(layout),
            duration: "0.75s",
            animateViewport: true,
            easedAnimation: true,
            portAdjustmentPolicy: "lengthen",
            updateContentRect: true,
            allowUserInteraction: false,
            sequentialExecution: true,
            automaticEdgeGrouping: false,
            configureTableLayout: false
        });
        layoutExecutor.abortHandler.cancelDuration = TimeSpan.from("20s");
        if (layoutData) {
            layoutExecutor.layoutData = layoutData;
        }
        try {
            await layoutExecutor.start();
        }
        catch (err) {
            console.warn(err);
            errorHandler();
        }
        finally {
            this.$layoutRunning = false;
            doneHandler();
        }
    }
    createPreferredPlacementDescriptor(distanceToEdge) {
        return new PreferredPlacementDescriptor({
            sideOfEdge: LabelPlacements.ON_EDGE,
            placeAlongEdge: LabelPlacements.AT_CENTER,
            angle: 0.0,
            angleReference: LabelAngleReferences.RELATIVE_TO_EDGE_FLOW,
            distanceToEdge
        });
    }
}
export default LayoutConfiguration;
